import { identity, pickBy } from 'lodash-es'

export const formatDateTitle = (firstDay, isPhone, locale = 'en', daysRange = 7, formats = {}) => {
  const {
    phoneDayFormat = 'ddd',
    phoneDateFormat = 'MMM DD YYYY',
    monthFormat = 'MMM YYYY',
    firstMonthFormat = 'MMM',
    lastMonthFormat = 'MMM YYYY',
    firstYearFormat = 'MMM YYYY',
    lastYearFormat = 'MMM YYYY'
  } = pickBy(formats, identity)

  const lastDay = firstDay.clone().add(daysRange, 'days')

  if (isPhone) {
    return [
      firstDay.locale(locale).format(phoneDayFormat).toUpperCase(),
      firstDay.locale(locale).format(phoneDateFormat)
    ].join(', ')
  }

  if (firstDay.isSame(lastDay, 'month')) {
    return firstDay.locale(locale).format(monthFormat)
  }

  if (firstDay.isSame(lastDay, 'year')) {
    return `${firstDay.locale(locale).format(firstMonthFormat)} - ${lastDay.locale(locale).format(lastMonthFormat)}`
  }

  return `${firstDay.locale(locale).format(firstYearFormat)} - ${lastDay.locale(locale).format(lastYearFormat)}`
}
